import { TableHeadDataProps } from '../../components/Table/TableHead';

export const usersTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Name' },
  { id: 2, title: 'E-mail' },
  { id: 3, title: 'Phone' },
  { id: 4, title: 'Address' },
  { id: 5, title: 'Role' },
  { id: 6, title: 'Status' },
  { id: 7, title: 'Actions' },
];
export const adminUsersTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Name' },
  { id: 2, title: 'E-mail' },
  { id: 3, title: 'Phone' },
  { id: 4, title: 'Address' },
  { id: 5, title: 'Role' },
  { id: 6, title: 'Clinic' },
  { id: 7, title: 'Status' },
  { id: 8, title: 'Actions' },
];
